import "./footer.css"

const Footer = () => {
  return (
    <footer style={{ padding: " 20px 40px 0px", backgroundColor: "white" }} >


      <div className="footer-content">

        <p><span className='rmb_run_p'>RUN</span><span className='rmb_my_p'>MY</span><span className='rmb_bot_p'>BOT®</span></p> &nbsp;All Rights Reserved {new Date().getFullYear()}.
        {/* RUNMYBOT® All Rights Reserved. */}
      </div>


    </footer>
  )
}

export default Footer